// extracted by mini-css-extract-plugin
module.exports = {"portrait":"Icons_portrait__2x53N"};